<template>
  <li v-if="!item.hidden" class="AppActionBar-list-item" :class="item.style" :data-locator="item.locatorValue" :name="item.name">
    <slot>
      <template v-if="item.title">
        <AppTooltip :disabled="!item.disabled || !item.disabledTooltip">
          <template #activator="{ props }">
            <app-button 
              :disabled="item.disabled" 
              type="ghost" 
              :variant="item.variant || 'neutral'" 
              @click="item.action()"
              v-bind="props"
            >
              <template #left-icon>
                <app-material-icon :name="item.icon" color="inherit" />
              </template>
              <span>{{ item.title }}</span>
            </app-button>
          </template>
          <span>{{ item.disabledTooltip }}</span>
        </AppTooltip>
      </template>
    </slot>
  </li>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import AppTooltip from '@/common/AppTooltip.vue'
import { AppButtonVariant } from '@/design-system/buttons/AppButton.vue'

type ActionBarItemType = {
  name: string
  title?: string
  hidden?: boolean
  icon?: string
  style?: string
  locatorValue?: string
  variant?: AppButtonVariant
  disabled?: boolean
  disabledTooltip?: string
  action: () => void
}

export default defineComponent({
  name: 'AppActionBarListItem',
  components: {
    AppTooltip,
  },
  props: {
    item: {
      type:  Object as PropType<ActionBarItemType>,
      required: true,
    },
  },
})
</script>
